import styled from 'styled-components'

type ImageProps = {
  small?: boolean
}

export const Image = styled.img<ImageProps>`
  width: ${({ small }) => (small ? '2rem' : '2.5rem')};
  height: ${({ small }) => (small ? '2rem' : '2.5rem')};
  font-size: ${({ small }) => (small ? 'var(--text-1)' : 'var(--text-2)')};
  object-fit: cover;
  flex-shrink: 0;
`

Image.displayName = 'Image'
